<template>
    <b-field class="autocomplete-input-container" :class="{'show-icon': !isFetching}" :addons="false">
        <b-autocomplete
            v-model="autocompleteTerms"
            :data="autocompleteProductsList"
            field="name"

            :placeholder="$t('name_or_product_reference')"
            :size="'is-large '+(isFetching ? 'is-loading' : '')"
            :keep-first="true"
            :open-on-focus="false"
            @typing="getAsyncProductList"
            @select="option => autocompleteSelectProduct(option)"
            rounded
        >
          <template slot-scope="props">
              {{props.option.name}} <span class="product-category">{{getCategory(props.option.productRanges[0])}}</span>
          </template>
            <template slot="empty">
                <template v-if="autocompleteTerms.length < minCharCount">{{ $t("please_specify_at_least_x_characters", {count: minCharCount}) }}</template>
                <template v-else-if="isFetching">{{ $t("search_in_progress") }}</template>
                <template v-else>{{ $t("no_results_for_this_search") }}</template>
            </template>
        </b-autocomplete>
        <span class="icon-search" :class="brandColor"></span>
    </b-field>
</template>

<script>
    import speedTrackingMixins from "@/common/mixins/speedTracking"
    import productService from "@/services/serli/product";
    import {mapGetters, mapState} from "vuex";
    import {triggerTrackingEvent} from "@/common/helpers";

    export default {
        name: 'AutocompleteProduct',
        mixins: [
            speedTrackingMixins
        ],
        props: {
            category: {
                type: String,
                required: false,
                default: null
            },
            namePreset: {
                type: String,
                required: false,
                default: null
            },
            allBrands: {
                type: Boolean,
                required: false,
                default: false
            },
            allowOld: {
              type: Number,
              required:false,
              default: 0
            }
        },
        data() {
            return {
                autocompleteTerms: '',
                timeout: null,
                autocompleteProductsList: [],
                minCharCount: 2,
                isFetching: false,
                speedTrackingAutocomplete: null,
                startTime: new Date().getTime(),
            }
        },
      computed: {
        ...mapState({
          categories: state=>state.settings.asyncCategories
        }),
        ...mapGetters({
          localeKebabFormat: 'settings/localeKebabFormat',

        }),
      },
        created(){
          if(this.namePreset)
              this.autocompleteTerms = this.namePreset;

          const _self=this
          this.$root.$on('accessories_filters_reset', ()=>{
            console.log('ok')
            _self.autocompleteTerms=''
          })
        },
        methods: {
            async getAsyncProductList(name) {
                this.$emit('updateAutocompleteTerms', name);
                clearTimeout(this.timeout);
                this.timeout = setTimeout(async ()=> {
                    this.autocompleteProductsList = []
                    if (name.length < this.minCharCount)
                        return

                    this.isFetching = true
                    let autocompleteMachinesList = [];
                    let autocompleteAccessoriesList = [];
                    let autocompleteOptionList = [];
                    let autocompletServicesList = [];

                    const startTime = new Date().getTime();
                    var filter= [
                          {
                            type:'string',
                            attribute:'name',
                            value : name

                          }
                        ];

                    autocompleteMachinesList = await productService.list({filters: filter}, {
                        productType: this.category === 'attachments' ? 'accessory' : 'machines',
                        brand: !this.allBrands ? this.$store.state.settings.brand : null,
                        suggest:true,
                        locale:this.localeKebabFormat,
                        category: this.category || 'machines',
                        terms:name,
                        allowOld:this.allowOld
                    })
                    .then((response) => {
                        const results = response.data.data;
                        return results;
                    })


                    if(!this.category){
                        autocompleteAccessoriesList = await productService.list({filters: filter}, {
                            productType: 'accessory',
                            brand: !this.allBrands ? this.$store.state.settings.brand : null,
                            category: 'attachments',
                            suggest:true,
                            locale: this.localeKebabFormat,
                            terms:name,
                        })
                        .then((response) => {
                            const results = response.data.data;
                            results.forEach(result => result.type = 'attachment')
                            return results;
                        });

                        autocompleteOptionList = await productService.list({filters: filter}, {
                            productType: 'option',
                            brand: !this.allBrands ? this.$store.state.settings.brand : null,
                            category: 'Options',
                            country: null, // Important car les options ne sont pas lié a une region
                            suggest:true,
                            locale: this.localeKebabFormat,
                            terms:name,
                        })
                        .then((response) => {
                            const results = response.data.data;
                            results.forEach(result => result.type = 'option')
                            return results;
                        });

                        autocompletServicesList = await productService.list({filters: filter}, {
                            productType: 'service',
                            brand: !this.allBrands ? this.$store.state.settings.brand : null,
                            category: 'services',
                            suggest:true,
                            locale: this.localeKebabFormat,
                            terms:name,
                        })
                        .then((response) => {
                            const results = response.data.data;
                            results.forEach(result => result.type = 'service')
                            return results;
                        });
                    }

                    // if(this.category !== 'machines')
                    //     this.speedTrackingAutocompleteProductTrigger(startTime, name);

                    this.autocompleteProductsList = autocompleteMachinesList
                        .concat(autocompleteAccessoriesList)
                        .concat(autocompleteOptionList)
                        .concat(autocompletServicesList)
                    this.isFetching = false
                    this.startTime = startTime
                }, 500);
            },
            autocompleteSelectProduct(product){
                /*gtag('event', 'click_autocomplete_product', {
                    'event_category': 'click',
                    'event_label': `Clic sur une typologie de produit dans la recherche : ${product.name}`
                });*/

                // triggerTrackingEvent('click_autocomplete_product', 'click', `Clic sur une typologie de produit dans la recherche : ${product.name}`)
                this.speedTrackingAutocompleteProductTrigger(this.startTime, this.autocompleteTerms, product);
                this.$emit('productSelected', product)
            },
          getCategory(codes) {
              let label='';
              let category=null;
              codes.forEach((code)=>{
                  category=this.categories.find((cat)=>cat.code===code)
                if(category) label='('+category.label+')'
              })

              return label
          }
        }
    }
</script>

<style lang="scss">
    .autocomplete-input-container {
        position: relative;
        text-align: left;
        min-width: 320px;
      max-width:100%!important;
        margin: 0 auto;

        @media #{$mq_phone} {
          min-width: auto;
          margin-left: 20px;
          margin-right: 20px;
        }

        @media #{$mq_phone_min} {
          width: 400px;
        }

        @media #{$mq_tablet_min} {
          width: 480px;
        }

        @media #{$mq_desktop} {
          width: 540px;
        }

        &.show-icon {
            [class^="icon-"], [class*=" icon-"] {
                display: inline-block;
            }
        }

        .input {
            padding-right: 45px;
        }

        [class^="icon-"], [class*=" icon-"] {
            display: none;
            position: absolute;
            z-index: 2;
            top: 50%;
            margin-top: -9px;
            right: 18px;
            font-size: 17px;
        }

        .product-category {
            color: #696969;
            font-size: .8rem;
            line-height: 1.5;
        }
    }
</style>